export default __webpack_public_path__ + "static/media/simgecan10.02ac1ccd.jpg";